import { inject, injectable } from 'inversify';
import React from 'react';

import { TUseApiRequestWrapper } from '../../core/domain/interfaces';
import { ReactHookFactory } from '../infrastructrue/factories/React.hook.factory';
import { TUseToggleComponentHook } from '../infrastructrue/types';

@injectable()
export class ReactHookService {
  constructor(
    @inject(ReactHookFactory)
    private readonly reactHookFactory: ReactHookFactory,
  ) {}

  public composeUseToggleComponentHook(payload: {
    ReactComponent: React.FC<{
      isToggleActive: boolean;
      toggleTenantSwitcherComponent: () => void;
    }>;
  }): TUseToggleComponentHook {
    const { ReactComponent } = payload;

    return this.reactHookFactory.composeUseToggleComponentHook({
      ReactComponent,
    });
  }

  public composeUseApiRequestWrapper(): TUseApiRequestWrapper {
    return this.reactHookFactory.composeUseApiRequestWrapper();
  }
}
